(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__productCardModalInit) return;
    window.__productCardModalInit = true;

    function openModal(modalId) {
      var modal = document.getElementById('product-options-modal-' + modalId);
      if (!modal) return;

      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }

      modal.style.position = 'fixed';
      modal.style.top = '0';
      modal.style.left = '0';
      modal.style.width = '100vw';
      modal.style.height = '100vh';
      modal.style.zIndex = '9999';
      modal.style.display = 'flex';
      modal.style.alignItems = 'center';
      modal.style.justifyContent = 'center';

      var overlay = modal.querySelector('.product-options-modal-overlay');
      if (overlay) {
        overlay.style.position = 'fixed';
        overlay.style.top = '0';
        overlay.style.left = '0';
        overlay.style.width = '100%';
        overlay.style.height = '100%';
      }

      document.body.style.overflow = 'hidden';
    }

    function closeModal(modalId) {
      var modal = document.getElementById('product-options-modal-' + modalId);
      if (modal) {
        modal.style.display = 'none';
        document.body.style.overflow = '';
      }
    }

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-open-modal]');
      if (openBtn) {
        e.preventDefault();
        e.stopPropagation();
        openModal(openBtn.getAttribute('data-open-modal'));
        return;
      }

      var closeBtn = e.target.closest('[data-close-modal]');
      if (closeBtn) {
        e.preventDefault();
        e.stopPropagation();
        closeModal(closeBtn.getAttribute('data-close-modal'));
        return;
      }

      var qBtn = e.target.closest('[data-quantity-action]');
      if (qBtn) {
        var action = qBtn.getAttribute('data-quantity-action');
        var productId = qBtn.getAttribute('data-product-id');
        var blockId = qBtn.getAttribute('data-block-id');
        var displayInput = document.getElementById('quantity-display-' + productId + '-' + blockId);
        var hiddenInput = document.getElementById('quantity-' + productId + '-' + blockId);
        if (!displayInput) return;
        var val = parseInt(displayInput.value) || 1;
        var min = parseInt(displayInput.getAttribute('min')) || 1;
        var max = parseInt(displayInput.getAttribute('max')) || 99;
        if (action === 'increase' && val < max) val++;
        if (action === 'decrease' && val > min) val--;
        displayInput.value = val;
        if (hiddenInput) hiddenInput.value = val;
        return;
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.product-options-modal').forEach(function (modal) {
          if (modal.style.display === 'flex') {
            modal.style.display = 'none';
            document.body.style.overflow = '';
          }
        });
      }
    });
  })();



  // Dietary filter tag pill sync
(function () {
  var DIETARY_FILTER_PARAM = 'filter.p.m.custom.dietary';

  function getActiveDietaryFilters() {
    var params = new URLSearchParams(window.location.search);
    var active = params.getAll(DIETARY_FILTER_PARAM).map(function (v) {
      return v.toLowerCase();
    });
    return active;
  }

  function syncTagPills() {
    var activeFilters = getActiveDietaryFilters();

    document.querySelectorAll('.product-card-tags-container').forEach(function (container) {
      container.querySelectorAll('.product-card-tag-pill').forEach(function (pill) {
        var pillText = pill.textContent.trim().toLowerCase();
        if (activeFilters.length === 0) {
          // No dietary filter active — show all pills
          pill.style.display = '';
        } else {
          // Only show pills that match an active filter
          pill.style.display = activeFilters.indexOf(pillText) !== -1 ? '' : 'none';
        }
      });
    });
  }

  // Run on page load
  syncTagPills();

  // Re-run when Shopify's filter updates the page via AJAX (history state changes)
  window.addEventListener('popstate', syncTagPills);

  // Also watch for URL changes triggered by facet-inputs-component
  var _pushState = history.pushState;
  history.pushState = function () {
    _pushState.apply(history, arguments);
    syncTagPills();
  };

  var _replaceState = history.replaceState;
  history.replaceState = function () {
    _replaceState.apply(history, arguments);
    syncTagPills();
  };

  // Watch for DOM mutations (AJAX re-renders of product cards)
  var observer = new MutationObserver(function (mutations) {
    var shouldSync = mutations.some(function (m) {
      return m.addedNodes.length > 0;
    });
    if (shouldSync) syncTagPills();
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
  } catch(e) { console.error(e); }
})();

})();
